var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('signup-form',{staticClass:"py-5",attrs:{"apiURL":"https://backend.smartquick.com.co","smartQuickURL":"https://enterprise.smartquick.com.co"}})}
var staticRenderFns = []

export { render, staticRenderFns }